var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ref } from "vue";
import { useDatatypesMapperStore } from "@/stores/datatypesMapperStore";
export function useDatatypesMapper() {
    const datatypesMapperLoading = ref(true);
    const datatypesMapper = ref(null);
    const datatypesMapperStore = useDatatypesMapperStore();
    const datatypes = ref([]);
    function getDatatypesMapper() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield datatypesMapperStore.createMapper();
                datatypesMapper.value = datatypesMapperStore.datatypesMapper;
                if (datatypesMapperStore.datatypesMapper) {
                    datatypes.value = datatypesMapperStore.datatypesMapper.datatypes;
                }
            }
            catch (e) {
                console.error("unable to create datatypes mapper\n", e);
            }
            finally {
                datatypesMapperLoading.value = false;
            }
            if (!datatypesMapperStore.datatypesMapper) {
                throw "Error creating datatypesMapper";
            }
        });
    }
    getDatatypesMapper();
    return { datatypes, datatypesMapper, datatypesMapperLoading };
}
